export default __webpack_public_path__ + "static/banner-three-347db0a5fdbe82836f67c17b3f76a9be.jpg";